<script>
    import { beforeUpdate, afterUpdate, onMount, createEventDispatcher } from 'svelte';
    import { next_session, user } from './stores.js';
    import TaskList from './components/TaskList.svelte';
    import Audioplayer from './components/Audioplayer.svelte';
    import ShowAndTell from './ShowAndTell.svelte';
    import Tutorials from './Tutorials.svelte';
    import HacoModal from './HacoModal.svelte';
    import ViewHighlight from './ViewHighlight.svelte';

    let timer;
    let modal;
    let w;
    let breakpoint = 532;

    const dispatch = createEventDispatcher();


    // let next_session;

	afterUpdate(() => {
		console.log("after update");
        if (timer) {
            timer.restart($next_session);
        }
	});


    onMount(async() => {
		const containerEl = document.querySelector('#container');
		const coverEl = document.querySelector('#cover');
		let randomNumber = Math.floor(Math.random() * Math.floor(25));
		// console.log('random Number: ',randomNumber);
		const imageURL = `https://placeimg.com/1000/1000/nature/${randomNumber}`;
		const newImage = new Image();
		newImage.onload = function(){
			containerEl.style.backgroundImage = `url(${imageURL})`;
			containerEl.style.backgroundSize = "cover";
			containerEl.style.backgroundPosition = "center";
			coverEl.style.opacity = "0.5";
		}
		newImage.src = imageURL;

    });


	function handleLaunchHACOCloseModal(event) {
		console.log("handleLaunchHACO");
        dispatch('launchHACO', {
            id: event.detail.id
        });
        console.log("close modal");
        modal = "";
	}

    // function launchHACO(){
    //     console.log('launchHACO: ', hacoId);
    //     dispatch('launchHACO', {
    //         id: hacoId
    //     });
    // }

</script>
<svelte:window bind:innerWidth={w}/>
<div id="container">
    <main>
        <section id="tasks">
            <TaskList />
        </section>
        <section>
            <div id="audioPlayer"><Audioplayer /></div>
            <dwane-timer bind:this={timer} timer-deadline={$next_session} countdown-start="3600000" timer-orientation="{w < breakpoint ? 'horizontal' : 'vertical'}"></dwane-timer>
            <button on:click={ () => modal = "tutorials" }>view tutorials</button>
            {#if $user && $user.isBanned}
                <div></div>
            {:else}
                <div>
                    <fieldset>
                        <legend>HACO</legend>
                        <button on:click={ () => modal = "hacoCreate" }>create</button><button on:click={ () => modal = "hacoView" }>view</button>
                    </fieldset>
                    <br/><button on:click={ () => modal = "showAndTell" }>show & tell signup</button>
                    {#if $user && $user.highlightStatus}
                        <fieldset class="highlight">
                            <legend>Hightlight</legend>
                            status: {$user.highlightStatus}
                            {#if $user.highlightStatus === "done"}
                                <br/><button on:click={ () => modal = "viewHighlight" }>view</button>
                            {/if}
                        </fieldset>
                    {/if}
                </div>
            {/if}
        </section>    
    </main>
    <div id="cover"></div>
    {#if modal}
        <div id="modal">
            <button id="closeModal" on:click={ () => modal = "" }>close</button>
            {#if modal==="tutorials"}
                <Tutorials />
            {:else if modal==="hacoCreate"}
                <HacoModal mode={"create"} on:launchHACOCloseModal={handleLaunchHACOCloseModal} />
            {:else if modal==="hacoView"}
                <HacoModal mode={"view"} on:launchHACOCloseModal={handleLaunchHACOCloseModal} />
            {:else if modal==="showAndTell"}
                <ShowAndTell />
            {:else if modal==="viewHighlight"}
                <ViewHighlight />
            {/if}
        </div>
    {/if}
</div>

<style>
    #container {
        /* display: flex;
        align-items: center;
        justify-content: center; */
        height: 100%;
        width: 100%;
        /* position: absolute; */
		top: 0;
		left: 0;
        position: relative;

    }
    main {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        position: absolute;
        z-index: 1;
    }
    section {
        margin: 5px;
        /* width: 100%; */
    }
    #tasks {
        width: clamp(300px, 100%, 550px);
        margin-top: 75px;
        /* max-width: 550px; */
    }
    legend {
        text-align: left;
        background-color: #fff;
        color: #000;
        padding: 3px 6px;
        font-weight: bold;
    }
    #cover {
		width: 100%;
		height: 100%;
		background-color: black;
		opacity: 1;
		transition: opacity 3s;
		/* position: absolute; */
		top: 0;
		left: 0;
	}

	#cover.imageLoaded {
		/* opacity: .5; */
		background: rgba(0, 0, 0, 0.9);
	}

    #audioPlayer {
        position: absolute;
        top: 0;
        left: 0;
    }

    dwane-timer {
        --dwane-timer-font-family: "Roboto Mono";
        --dwane-timer-weekday-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-date-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-time-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-countdown-font-size: clamp(5rem, 1.5vw, 9rem);
        --dwane-timer-text-color: white;
        opacity: 0;
        transition:opacity 0.4s ease-in;
    }
    dwane-timer:defined {
        opacity: 1;
    }

    button {
        margin: 10px;
        cursor: pointer;
    }

    #modal {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100vw;
        background-color: white;
        z-index: 10;
    }
    #closeModal {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 10;
    }

    @media (max-width: 532px){
        #tasks {
            position: absolute;
            bottom: 0;
        }
    }

    fieldset.highlight {
        background: white;
    }

</style>